import { makeAutoObservable } from 'mobx'
import { UserRequest } from '../requests/UserRequest'
import { getNameInCapitalize } from '../utils/common'

class UserStore {
  /** Get users list */
  userList = []
  mentionUserList = []
  userHasAdminList = []
  userWithImageId = []
  userOfDepartmentData = []
  userListTotalCount = 0
  userListPageIndex = 0
  userListPageSize = 10
  userListKeyword = undefined
  userListStatus = undefined
  userListDepartmentCode = undefined
  userListPositionCode = undefined
  userListSortDirection = undefined
  userListSortBy = undefined
  userListHasAdmin = undefined
  userListSortByDepartment =
    'departmentCode,desc,HDQT,BDH,BTCNS,BTCKT,BTKTH,BKTKTNB,BVTB,BCB%26DVHH,BTTKH,BPC%26QTRR,BTGTT,VPCQTCT,BCNTT,CDTCT'
  companyCode = null
  selectGroupData = []
  groupList = []
  constructor() {
    makeAutoObservable(this)
  }
  setSelectGroupData = payloadSelect => {
    this.selectGroupData = payloadSelect
  }
  clearSelectGroupData = () => {
    this.selectGroupData = []
  }
  defaultQueryParams = {
    page: 0,
    size: 10,
  }
  setDefaultQueryParams = payload => {
    this.defaultQueryParams = payload
  }

  getUserList = () => {
    return new Promise((resolve, reject) => {
      UserRequest.getUserList(
        this.userListPageSize,
        this.userListPageIndex,
        this.userListKeyword,
        this.userListDepartmentCode,
        this.userListStatus,
        this.userListSortDirection,
        this.userListSortBy,
        false,
        this.userListSortByDepartment,
        this.companyCode,
        this.userListPositionCode
      )
        .then(response => {
          this.userListTotalCount = response.data.total_count
          this.userList = [...this.userList, ...response.data.data]
          this.userHasAdminList = response.data.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  getUserListV2 = () => {
    return new Promise((resolve, reject) => {
      const requestTrue = UserRequest.getUserList(
        999,
        this.userListPageIndex,
        this.userListKeyword,
        this.userListDepartmentCode,
        this.userListStatus,
        this.userListSortDirection,
        this.userListSortBy,
        true,
        this.userListSortByDepartment,
        this.companyCode,
        this.userListPositionCode
      )

      const requestFalse = UserRequest.getUserList(
        999,
        this.userListPageIndex,
        this.userListKeyword,
        this.userListDepartmentCode,
        this.userListStatus,
        this.userListSortDirection,
        this.userListSortBy,
        false,
        this.userListSortByDepartment,
        this.companyCode,
        this.userListPositionCode
      )

      Promise.all([requestTrue, requestFalse])
        .then(([responseTrue, responseFalse]) => {
          const combinedData = [
            ...responseTrue.data.data,
            ...responseFalse.data.data,
          ]
          this.userListTotalCount =
            responseTrue.data.total_count + responseFalse.data.total_count
          this.userList = combinedData
          this.userHasAdminList = combinedData
          this.userWithImageId = combinedData.map(item => ({
            username: item.username,
            name_uppercase: item.name_uppercase,
            department: item.department.name,
            image_id: item.imageId,
          }))
          resolve({
            data: { total_count: this.userListTotalCount, data: combinedData },
          })
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getMentionUserList = has_admin => {
    return new Promise((resolve, reject) => {
      UserRequest.getMentionUserList(has_admin)
        .then(response => {
          this.mentionUserList = response.data.userDetails.map(user => {
            return {
              id: user.userCode,
              display: getNameInCapitalize(user.fullName),
              username: user.user_name,
              image: user.image,
            }
          })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getAllUsers = () => {
    return UserRequest.getMentionUserList(true)
  }

  setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  userOfDepartmentListTotalCount = 0
  userOfDepartmentListPageIndex = 0
  userOfDepartmentListPageSize = 10
  userOfDepartmentListByDepartmentCode = undefined

  clearUserOfDepartmentData = () => {
    this.userOfDepartmentListPageIndex = 0
    this.userOfDepartmentData = []
  }
  getUserListByDepartment = department_name => {
    return new Promise((resolve, reject) => {
      UserRequest.getUserList(
        this.userOfDepartmentListPageSize,
        this.userOfDepartmentListPageIndex,
        '',
        this.userOfDepartmentListByDepartmentCode,
        true,
        undefined,
        undefined,
        null,
        null,
        this.companyCode
      )
        .then(response => {
          this.userOfDepartmentListTotalCount = response.data.total_count
          this.userOfDepartmentData = [
            ...this.userOfDepartmentData,
            ...response.data.data,
          ]
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  userOfPositionListTotalCount = 0
  userOfPositionListPageIndex = 0
  userOfPositionListPageSize = 10
  userOfPositionListByPositionCode = undefined

  getUserListByPosition = () => {
    return new Promise((resolve, reject) => {
      UserRequest.getUserList(
        this.userOfPositionListPageSize,
        this.userOfPositionListPageIndex,
        '',
        undefined,
        undefined,
        undefined,
        undefined,
        null,
        null,
        this.companyCode,
        this.userOfPositionListByPositionCode
      )
        .then(response => {
          this.userOfPositionListTotalCount = response.data.total_count
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  changeUserListKeyword = keyword => {
    this.userListPageIndex = 0
    this.userListKeyword = keyword && keyword.trim()
  }
  changeUserListSortBy = type => {
    this.userListPageIndex = 0
    this.userListSortBy = type
  }
  changeUserListSortDirection = direction => {
    this.userListPageIndex = 0
    this.userListSortDirection = direction
  }
  changeUserListStatus = status => {
    this.userListPageIndex = 0
    this.userListStatus = status
  }
  changeUserListDepartment = code => {
    this.userListPageIndex = 0
    this.userListDepartmentCode = code
  }
  changeUserListPageIndex = pageIndex => {
    this.userListPageIndex = pageIndex
  }
  changeUserListPageSize = pageSize => {
    this.userListPageSize = pageSize
  }
  clearUserListFilter = () => {
    this.userListStatus = undefined
    this.userListSortDirection = undefined
    this.userListSortBy = undefined
    this.userListDepartmentCode = undefined
  }

  /** Selected user */
  selectedUser = {}
  setSelectedUser = userInfo => {
    // console.log('setSelectedUser', toJS(userInfo))
    this.selectedUser = userInfo
  }
  updateSelectedUser = (key, val) => {
    this.selectedUser[key] = val
  }
  clearSelectedUser = () => {
    this.selectedUser = {}
  }

  /** Update user */
  updateUser = userInfoObj => {
    const { code } = this.selectedUser
    return new Promise((resolve, reject) => {
      UserRequest.updateUser(code, userInfoObj)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          // console.log(error)
          reject(error)
        })
    })
  }

  /** Update user roles */
  updateUserRoles = (userCode, rolesArr) => {
    return new Promise((resolve, reject) => {
      UserRequest.updateUserRole(userCode, rolesArr)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Update user commands */
  updateUserCommands = (userCode, userCommandsArr) => {
    return new Promise((resolve, reject) => {
      UserRequest.updateUserCommands(userCode, userCommandsArr)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          // console.log(error)
          reject(error)
        })
    })
  }

  /** Update user status */
  updateUserStatus = (userCode, toggleStatus) => {
    return new Promise((resolve, reject) => {
      UserRequest.updateUserStatus(userCode, toggleStatus)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          // console.log(error)
          reject(error)
        })
    })
  }

  /** Create user */
  createUser = userInfo => {
    return new Promise((resolve, reject) => {
      UserRequest.createUser(userInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** UpdateCurrentUser user */
  updateCurrentUser = userInfo => {
    return new Promise((resolve, reject) => {
      UserRequest.UpdateCurrentUser(userInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          // console.log(error)
          reject(error)
        })
    })
  }

  /** UpdateCurrentUserPassword user */
  updateCurrentUserPassword = submitData => {
    return new Promise((resolve, reject) => {
      UserRequest.UpdateCurrentUserPassword(submitData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getListAvatar = listUserCode => {
    return new Promise((resolve, reject) => {
      UserRequest.getListAvatar(listUserCode)
        .then(response => {
          // response.data.image.map(item => {
          //   const index = this.userList.data.findIndex(el => el.code === item.code);
          //   if (index > -1) {
          //     this.userList.data[index].image = item.image;
          //   }
          // })
          resolve(response.data.image)
        })
        .catch(error => {
          // console.log(error)
          reject(error)
        })
    })
  }

  preConnectCloud = () => {
    return new Promise((resolve, reject) => {
      UserRequest.preConnectCloud()
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          // console.log(error)
          reject(error)
        })
    })
  }

  /** Clear store */
  clearStore = () => {
    this.userList.length = 0
    this.userListPageIndex = 0
    this.userListPageSize = 10
    this.userListTotalCount = 0
    this.userListKeyword = undefined
    this.userListStatus = undefined
    this.userListDepartmentCode = undefined
    this.userListSortDirection = undefined
    this.userListSortBy = undefined
    this.userListHasAdmin = undefined
    this.selectedUser = {}
    this.companyCode = null
  }
}
const userStore = new UserStore()
export default userStore
